/** Vendor suitability range for max center-to-center distance (mm). */
export type VanDerValkMaxCtcDistanceRange = { min: number; max: number }

export function parsePositiveNumberMm(value: unknown): number | undefined {
  if (value === undefined || value === null || value === '') {
    return undefined
  }
  const n = typeof value === 'number' ? value : parseInt(String(value).trim(), 10)
  if (!Number.isFinite(n) || n < 1) {
    return undefined
  }
  return n
}

export function isMaxCtcDistanceRange(value: unknown): value is VanDerValkMaxCtcDistanceRange {
  return (
    value != null &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    typeof (value as VanDerValkMaxCtcDistanceRange).min === 'number' &&
    typeof (value as VanDerValkMaxCtcDistanceRange).max === 'number'
  )
}

/** Scalar mm value for BOM: user pick, or default to range ``max`` when vendor only supplies a range. */
export function resolveMaxCtcDistanceForBom(value: unknown): number | undefined {
  if (isMaxCtcDistanceRange(value)) {
    return value.max
  }
  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (trimmed.startsWith('{')) {
      try {
        const parsed = JSON.parse(trimmed) as unknown
        if (isMaxCtcDistanceRange(parsed)) {
          return parsed.max
        }
      } catch {
        // fall through to scalar parse
      }
    }
  }
  return parsePositiveNumberMm(value)
}

export function maxCtcDistanceOptionsFromRange(range: VanDerValkMaxCtcDistanceRange): string[] {
  const opts = [String(range.min)]
  if (range.max !== range.min) {
    opts.push(String(range.max))
  }
  return opts.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
}

export function isScalarWithinMaxCtcDistanceRange(
  scalar: number,
  range: VanDerValkMaxCtcDistanceRange
): boolean {
  return scalar >= range.min && scalar <= range.max
}
